<template>
    <div class="judge pt-5">
        <div class="w-100 mb-3 text-center">
            <h3 class="text-uppercase logo animate__animated animate__fadeIn">I Giudici</h3>
        </div>
        <carousel :autoplay="true" :scrollPerPage="true" :perPageCustom="[[300, 1], [768, 3]]">
            <slide class="px-2">
                <div class="animate__animated animate__backInLeft">
                    <div class="hover-judge">
                        <img class="img-fluid" src="../assets/judge/gigio_attanasio-670x1024.jpg">
                        <div class="info-judge">
                            <b>Gigio Attanasio</b>, 85 mila iscritti e oltre 12 milioni di visualizzazioni
                            totali su YouTube con un successo in continuo aumento. Affascinato come Ulisse dal canto ipnotico del
                            lievito, e alla ricerca (forse impossibile) della pizza perfetta.
                            <div class="mt-4 text-center w-100 social">
                                <a href="https://www.facebook.com/impastoinfuga/" target="_blank"><font-awesome-icon class="mr-3" :icon="['fab', 'facebook']" /></a>
                                <a href="https://www.youtube.com/channel/UCVdB3KylRS2qUJS1Aohabmg" target="_blank"><font-awesome-icon class="mr-3" :icon="['fab', 'youtube']" /></a>
                                <a href="https://www.instagram.com/gigiopizza" target="_blank"><font-awesome-icon :icon="['fab', 'instagram']" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </slide>
            <slide class="px-2">
                <div class="animate__animated animate__backInUp">
                    <div class="hover-judge">
                        <img class="img-fluid" src="../assets/judge/antonio_pascarella-670x1024.jpg">
                        <div class="info-judge long"><b>Antonio Pascarella</b>, è un videomaker appassionato di pizza napoletana. 
                            Conosciuto sul web con il suo canale YouTube Malati di Pizza. Un progetto nato da lontano, che nel corso degli anni ha subito una continua evoluzione 
                            e lo ha visto affermarsi come uno dei canali più quotati sulla pizza fatta in casa.
                            <div class="mt-4 text-center w-100 social">
                                <a href="https://www.facebook.com/MalatidiPizza" target="_blank"><font-awesome-icon class="mr-3" :icon="['fab', 'facebook']" /></a>
                                <a href="https://www.youtube.com/channel/UCUiAWKABE_JgTn7mUu0yO7g" target="_blank"><font-awesome-icon class="mr-3" :icon="['fab', 'youtube']" /></a>
                                <a href="https://www.instagram.com/malati_di_pizza" target="_blank"><font-awesome-icon :icon="['fab', 'instagram']" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </slide>
           <slide class="px-2">
                <div class="animate__animated animate__backInRight">
                    <div class="hover-judge">
                        <img class="img-fluid" src="../assets/judge/vincenzo_viscusi-e1620655989194.jpg">
                        <div class="info-judge long"><b>Vincenzo Viscusi</b>, è molto più di un comune appassionato. 
                            Per lui la pizza non è semplicemente cibo ma un modo per raccontare il mondo: emozioni, culture, tradizioni. <br>
                            Ed è grazie alla pizza che riesce a sentirsi sempre a casa anche a kilometri di distanza
                            <div class="mt-4 text-center w-100 social">
                                <a href="https://www.youtube.com/channel/UCds9YjVefaj8tSx1rPJTV9g" target="_blank"><font-awesome-icon class="mr-3" :icon="['fab', 'youtube']" /></a>
                                <a href="https://www.instagram.com/vincenzoviscusi/?hl=it" target="_blank"><font-awesome-icon :icon="['fab', 'instagram']" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </slide>
        </carousel>
    </div>
</template>


<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'Judges',
    components: {
        Carousel,
        Slide
    }
}
</script>


<style scoped>
.judge .social svg {
    font-size: 24px;
}

.hover-judge {
    position: relative;
    overflow: hidden;
    border-radius: 50px;
    border: 4px solid rgb(0 0 0 / 15%);
}

.info-judge {
    position: absolute;
    color: black;
    left: 0;
    padding: 20px;
    bottom: -40px;
    height: 0px;
    background: rgb(255 255 255 / 70%);
    backdrop-filter: blur(10px);
    border-top: none;
    transition: height .25s ease-in-out;
}

.hover-judge:hover .info-judge {
    height: 290px;
    transition: height .25s ease-in;
}
.hover-judge:hover .info-judge.long {
    height: 338px;
}

.VueCarousel-dot-container button {
    margin-top:0;
}

.VueCarousel-dot-container .VueCarousel-dot--active {
    background-color: #e91e63!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Judges.vue